<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" @click="on_click()">
		<path fill-rule="evenodd" clip-rule="evenodd" d="M1 11.5C2.73 7.11 7 4 12 4C17 4 21.27 7.11 23 11.5C21.27 15.89 17 19 12 19C7 19 2.73 15.89 1 11.5ZM3.18 11.5C4.83 14.87 8.21 17 12 17C15.79 17 19.17 14.87 20.82 11.5C19.17 8.13 15.79 6 12 6C8.21 6 4.83 8.13 3.18 11.5Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M7.5 11.5C7.5 9.02 9.52 7 12 7C14.48 7 16.5 9.02 16.5 11.5C16.5 13.98 14.48 16 12 16C9.52 16 7.5 13.98 7.5 11.5ZM9.5 11.5C9.5 12.88 10.62 14 12 14C13.38 14 14.5 12.88 14.5 11.5C14.5 10.12 13.38 9 12 9C10.62 9 9.5 10.12 9.5 11.5Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>